import { createAction } from 'redux-actions';

import { CLEAR_MONITORING_QUEUE_ENTRY_DETAILS } from '../types';

export const clearMonitoringQueueEntryDetails = createAction(CLEAR_MONITORING_QUEUE_ENTRY_DETAILS);


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/actions/clearMonitoringQueueEntryDetailsActions.js